export enum CustomErrorType {
  INTERNAL_SERVER_ERROR = 'Internal Server Error',
  GENERIC = 'Generic Error',
  INVALID_CONTENT = 'Invalid Content',
  NOT_FOUND = 'Not Found',
  ALREADY_EXISTS = 'Already Exists',
  UNAUTHORIZED = 'Unauthorized',
  UNAUTHENTICATED = 'Unauthenticated',
  NOT_MODIFIED = 'Not Modified',
  INVALID_TOKEN_SPECIFIED = 'Invalid token specified',
}
